module.exports = __webpack_public_path__ + "static/img/jiejuefangan.ae18e41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/jiejuefangan.jpg
// module id = Ds2x
// module chunks = 2